"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var states_1 = require("../../../common/constants/states");
var BillingGateway_1 = require("../../../classes/billing/BillingGateway");
var payment_methods_1 = require("../../../common/constants/payment_methods");
var months_and_years_1 = require("../../../common/constants/months_and_years");
var months_and_years_2 = require("../../../common/constants/months_and_years");
var Coupon_1 = require("../../../classes/Coupon");
var Teller_1 = require("../../../../DriveScout/Billing/Teller");
var Student_1 = require("../../../classes/Student");
var Product_1 = require("../../../classes/Product");
var Address_1 = require("../../../classes/Address");
var CreditCard_1 = require("../../../classes/CreditCard");
var PaymentRequest_1 = require("../../../common/payments/PaymentRequest");
var dsStudentOrderFormController = /** @class */ (function () {
    function dsStudentOrderFormController($scope, $state, $location, UsersModel, FlashService, UserService, OrdersModel, CreateOrderService, CouponsModel) {
        var _this = this;
        /**
         * The PayPal approval's key, held from its create until PayPalCard's
         * capture ends. A card order's key is the host page's: it sends that order.
         */
        this.paypalApproval = new PaymentRequest_1.PaymentRequest();
        this.$state = $state;
        this.UsersModel = UsersModel;
        this.OrdersModel = OrdersModel;
        this.CouponsModel = CouponsModel;
        this.FlashService = FlashService;
        this.billingAddressDoesNotAlreadyExist = false;
        this.proceedToPayment = this.proceedToPayment.bind(this);
        this.showUseExistingPaymentMethodUI = false;
        this.student = UserService.getCurrentUser();
        this.returnUrl = $location.absUrl() + "?student_id=" + this.student.id;
        this.inDollars = Teller_1.inDollars.bind(this);
        this.setStudentCart = this.setStudentCart.bind(this);
        this.handleAuthorizeCard = this.handleAuthorizeCard.bind(this);
        this.handleCompletedConfirmationToken =
            this.handleCompletedConfirmationToken.bind(this);
        this.tokenizationSupported = this.tokenizationSupported.bind(this);
        this.createPaypalOrder = this.createPaypalOrder.bind(this);
        this.handlePaypalCardTokenCreated = this.handlePaypalCardTokenCreated.bind(this);
        var $cashier = CreateOrderService.cashier();
        this.$cashier = $cashier;
        this.addresses = this.$cashier.addresses();
        this.billingAddress = {
            street: "",
            city: "",
            state: "",
            zip: "",
        };
        var policies = this.$cashier.policies();
        this.gateway = policies
            .getPolicyByName("billing")
            .getMetaValueByKey("billing_gateway");
        this.gateway_config = (0, BillingGateway_1.createBillingGatewayFromPolicies)(policies).config();
        this.surchargeBilledSeparately = this.$cashier.surchargeBilledSeparately();
        this.surchargeAmount = this.$cashier.surchargeAmountBilled();
        this.surchargeDetail = this.$cashier.surchargeDetail();
        if (this.$cashier.order().hasStudent() === true &&
            this.$cashier.order().student().$originalData.guardian) {
            var $payments = this.$cashier
                .order()
                .payments()
                .map(function (payment) {
                payment
                    .creditCard()
                    .setName(_this.$cashier.order().student().$originalData.guardian.firstname +
                    " " +
                    _this.$cashier.order().student().$originalData.guardian.lastname);
                return payment;
            });
            this.$cashier.order().setPayments($payments);
        }
        if (this.$cashier.order().hasStudent() === true &&
            !this.$cashier.order().student().$originalData.guardian) {
            var $payments = this.$cashier
                .order()
                .payments()
                .map(function (payment) {
                payment
                    .creditCard()
                    .setName(_this.$cashier.order().student().firstname() +
                    " " +
                    _this.$cashier.order().student().lastname());
                return payment;
            });
            this.$cashier.order().setPayments($payments);
        }
        this.payment_methods = structuredClone(payment_methods_1.PaymentMethods);
        this.months = months_and_years_1.Months;
        this.years = months_and_years_2.Years;
        this.states = states_1.States;
        if (this.gateway === "stripe") {
            this.stripeElementOptions = {
                currency: "usd",
                amount: undefined,
            };
        }
    }
    dsStudentOrderFormController.prototype.tokenizationSupported = function () {
        if (this.gateway === "authorize" &&
            this.gateway_config.authorize_api_client_key) {
            return true;
        }
        if (this.gateway === "stripe") {
            return true;
        }
        if (this.gateway === "square") {
            return true;
        }
        if (this.gateway === "paypal") {
            return true;
        }
        return false;
    };
    dsStudentOrderFormController.prototype.toggleUseExistingPaymentMethod = function () {
        this.showUseExistingPaymentMethodUI = !this.showUseExistingPaymentMethodUI;
        if (this.showUseExistingPaymentMethodUI === true) {
            delete this.$cashier.$order.$payments[0].$card.$payment_method_id;
            delete this.stripeElementOptions.amount;
        }
    };
    dsStudentOrderFormController.prototype.proceedToPayment = function (amount) {
        delete this.$cashier.$order.$payments[0].$card.$payment_method_id;
        this.showUseExistingPaymentMethodUI = false;
        this.$cashier.$order.$payments[0].$amount = amount;
        this.stripeElementOptions.amount = amount;
    };
    dsStudentOrderFormController.prototype.buttonText = function () {
        var msg = "Submit Order";
        if (this.$cashier.order().payments()[0].amount()) {
            msg += " and Payment for " + this.$cashier.amountPaidToday();
        }
        return msg;
    };
    dsStudentOrderFormController.prototype.removeCoupon = function () {
        this.$cashier.removeCoupon();
        this.$cashier.calculateTotal();
        this.updateAmountPaid();
    };
    dsStudentOrderFormController.prototype.updateAmountPaid = function () {
        if (this.$cashier.allowsPartialPayments() === false) {
            this.$cashier.order().payments()[0].setAmount(this.$cashier.totalDue());
        }
    };
    dsStudentOrderFormController.prototype.submitCouponCode = function () {
        var _this = this;
        var code = this.coupon_code;
        this.CouponsModel.validateCoupon(code).then(function (response) {
            var coupon = new Coupon_1.Coupon(response.coupon);
            _this.$cashier.addCoupon(coupon);
            delete _this.coupon_code;
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.updateAmountPaid();
        });
    };
    dsStudentOrderFormController.prototype.handleAmountChange = function () {
        // this.checkForOverpayment();
        this.$cashier.calculateTotal();
    };
    dsStudentOrderFormController.prototype.removeProductFromOrder = function (product) {
        this.$cashier.removeProduct(product);
        this.updateAmountPaid();
        this.$cashier.calculateTotal();
    };
    /**
     * If the billing address is already an available address that means its a pick-up location. Students cannot have
     * duplicate pick-up locations, so prevent the admin from being able to select the option to add it as a
     * pick-up location
     *
     * @param billingAddress
     * @returns {void}
     */
    dsStudentOrderFormController.prototype.checkBillingAddressAlreadyExistsAsPickupLocation = function (billingAddress) {
        if (billingAddress === void 0) { billingAddress = ""; }
        if (!billingAddress) {
            return false;
        }
        var addressExists = this.$cashier.addresses().filter(function (address) {
            return address.street().toLowerCase() === billingAddress.toLowerCase();
        }).length > 0;
        if (!addressExists) {
            this.billingAddressDoesNotAlreadyExist = true;
            this.$cashier.order().$payments[0].$add_billing_address_as_pickup_location = false;
        }
        else {
            this.billingAddressDoesNotAlreadyExist = false;
            this.$cashier.order().$payments[0].$add_billing_address_as_pickup_location = true;
        }
    };
    dsStudentOrderFormController.prototype.updateBillingAddressesList = function () {
        var _this = this;
        this.UsersModel.getPickupLocations(this.$cashier.order().student().id()).then(function (response) {
            _this.addresses = response.pickuplocations.map(function (location) {
                return location.address;
            });
        });
    };
    /**
     * Add a billing address to the order
     * @param {number} index
     * @param {Address} address
     */
    dsStudentOrderFormController.prototype.addBillingAddress = function (index, address) {
        this.billingAddress = {
            street: address.street(),
            city: address.city(),
            state: address.region(),
            zip: address.postalCode(),
        };
        this.$cashier.addBillingAddress(index, address);
        this.$cashier.calculateTotal();
        this.checkBillingAddressAlreadyExistsAsPickupLocation(address.street());
    };
    dsStudentOrderFormController.prototype.selectPaymentMethod = function (id, paymentIndex) {
        this.$cashier.setCustomerPaymentMethod(id, paymentIndex);
    };
    dsStudentOrderFormController.prototype.setStudentCart = function () {
        var payload = {
            products: [].concat(this.$cashier
                .order()
                .products()
                .map(function (product) {
                return { id: product.id() };
            })),
            payment_amount: this.$cashier.$order.$payments[0].$amount,
            payment_method: this.$cashier.$order.$payments[0].$payment_method,
        };
        if (this.$cashier.order().payments()[0].creditCard().billingAddress().street()) {
            payload.billing_address = {
                street: this.$cashier
                    .order()
                    .payments()[0]
                    .creditCard()
                    .billingAddress()
                    .street(),
                city: this.$cashier
                    .order()
                    .payments()[0]
                    .creditCard()
                    .billingAddress()
                    .city(),
                state: this.$cashier
                    .order()
                    .payments()[0]
                    .creditCard()
                    .billingAddress()
                    .region(),
                zip: this.$cashier
                    .order()
                    .payments()[0]
                    .creditCard()
                    .billingAddress()
                    .postalCode(),
            };
        }
        if (this.$cashier.order().coupon() != null) {
            payload.coupon = {
                id: this.$cashier.order().coupon().id(),
            };
        }
        return this.UsersModel.setStudentCart(this.$cashier.order().student().id(), payload)
            .then(function (response) {
            return response;
        })
            .catch(function (Error) {
            console.error(Error);
        });
    };
    dsStudentOrderFormController.prototype.handleAuthorizeCard = function (tokenData) {
        var valid = this.$cashier.order().products().length === 0 ||
            !this.$cashier.order().student() ||
            this.$cashier.order().submitted === true;
        if (!valid) {
            // fail
        }
        if (!this.gateway_config.authorize_api_client_key) {
            var card = new CreditCard_1.CreditCard(tokenData);
            if (tokenData.billing_address) {
                var address = new Address_1.Address(0, "", tokenData.billing_address.street, tokenData.billing_address.city, tokenData.billing_address.state, tokenData.billing_address.zip, 0, 0);
                card.setBillingAddress(address);
            }
            this.$cashier.order().payments()[0].$card = card;
        }
        else {
            // set token data on order
            this.$cashier.order().$payments = this.$cashier
                .order()
                .payments()
                .map(function (payment) {
                if (payment.paymentMethod() === "card") {
                    payment.creditCard().tokenize({ opaqueData: tokenData });
                }
                return payment;
            });
        }
        this.submit(this.$cashier.order());
    };
    dsStudentOrderFormController.prototype.handleCompletedConfirmationToken = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var cart, products, coupon, student, billing_address, payment_amount, payment_method, $products, $student, $coupon, address;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.UsersModel.getStudentCart(this.$cashier.order().student().id())];
                    case 1:
                        cart = (_a.sent()).cart;
                        products = cart.products, coupon = cart.coupon, student = cart.student, billing_address = cart.billing_address, payment_amount = cart.payment_amount, payment_method = cart.payment_method;
                        $products = products.map(function (p) { return new Product_1.Product(p); });
                        $student = new Student_1.Student(student);
                        this.$cashier.order().setProducts($products);
                        this.$cashier.order().setStudent($student);
                        if (coupon) {
                            $coupon = new Coupon_1.Coupon(coupon);
                            this.$cashier.order().setCoupon($coupon);
                        }
                        if (billing_address) {
                            address = new Address_1.Address(0, "", billing_address.street, billing_address.city, billing_address.state, billing_address.zip, 0, 0);
                            this.$cashier.$order.$payments[0].$card.$billing_address = address;
                        }
                        this.$cashier.$order.$payments[0].$amount = payment_amount;
                        this.$cashier.$order.$payments[0].$payment_method = payment_method;
                        // set token data on order
                        this.$cashier.order().$payments = this.$cashier
                            .order()
                            .payments()
                            .map(function (payment) {
                            if (payment.paymentMethod() === "card") {
                                if (_this.gateway === "stripe" || _this.gateway === "square") {
                                    payment.creditCard().tokenize(token.token);
                                    payment.$card.$save_payment_method = token.save_payment_method;
                                }
                                else {
                                    payment.creditCard().tokenize(token);
                                }
                            }
                            return payment;
                        });
                        this.submit(this.$cashier.order());
                        return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * Create a PayPal order for the student purchase
     * Called by PayPal Card component when user submits payment
     */
    dsStudentOrderFormController.prototype.createPaypalOrder = function () {
        return __awaiter(this, void 0, void 0, function () {
            var payload, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            total: this.$cashier.$order.$payments[0].$amount,
                            products: this.$cashier.order().products().map(function (p) { return ({ id: p.id() }); }),
                            student: {
                                id: this.$cashier.order().student().id(),
                            },
                            payments: [
                                {
                                    payment_method: "card",
                                    payment_amount: this.$cashier.$order.$payments[0].$amount,
                                },
                            ],
                        };
                        // Add coupon if provided
                        if (this.$cashier.couponProvided() && this.$cashier.coupon()) {
                            payload.coupon = this.$cashier.coupon().code();
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.OrdersModel.createPaypalOrder(this.paypalApproval.bodyFor(payload, function (requestId) { return (__assign(__assign({}, payload), { request_id: requestId })); }))];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.paypalApproval.settled(PaymentRequest_1.PaymentOutcome.failed(error_1));
                        throw error_1;
                    case 4: return [2 /*return*/, {
                            paypal_order_id: response.order_id,
                            drivescout_order_id: response.order.id,
                        }];
                }
            });
        });
    };
    /**
     * Handle PayPal card token created (after successful PayPal payment)
     * For PayPal, the order is already complete after the approve endpoint is called.
     * We just need to show success and redirect.
     */
    dsStudentOrderFormController.prototype.handlePaypalCardTokenCreated = function (tokenData) {
        // PayPal order is already complete after the approve endpoint
        // Show success message and redirect to orders page
        this.paypalApproval.settled(PaymentRequest_1.PaymentOutcome.succeeded());
        this.FlashService.setMessage({
            type: "success",
            message: "Your order has been placed successfully!",
        });
        // Redirect to student orders page
        this.$state.go("drivecoach.student.orders");
    };
    return dsStudentOrderFormController;
}());
dsStudentOrderFormController.$inject = [
    "$scope",
    "$state",
    "$location",
    "UsersModel",
    "FlashService",
    "UserService",
    "OrdersModel",
    "CreateOrderService",
    "CouponsModel",
];
exports.default = dsStudentOrderFormController;
